module.exports = __webpack_public_path__ + "img/calendar-blue.a2edcae5.svg";